import dayjs from 'dayjs'

export default {

  // November 26, 2020
  format (timestamp: number | string, formatter = 'MMMM DD, YYYY'): string {
    return dayjs(timestamp).format(formatter)
  },
  checkDateSameDay (start: number, end: number) {
    return dayjs(start).isSame(dayjs(end), 'day')
  },
  // 根据配置的时区来设置时间
  getGMTOffsetTimestamp (timestamp: number, timezone: string) {
    const date = new Date(timestamp)
    // 用户本地时间和目标时间的时间差
    const offset = date.getTimezoneOffset()
    const ISOTimestamp = timestamp + offset * 60 * 1000
    // 计算目标时区的时间
    const reg = new RegExp(/([+]|[-])(\d+(:?\d+)?)$/i)
    // 有两种格式，不带分钟和带分钟的，这里要根据情况来处理
    // 1. GMT +9; 2.GMT +9:30
    const timezoneStr = reg.exec(timezone)?.[0]
    const timezoneOffsetHour = timezoneStr?.split(':')?.[0] || 0
    const timezoneOffsetMinutes = timezoneStr?.split(':')?.[1] || 0
    // const timezoneOffset = Number(reg.exec(timezone)?.[0]) || 0
    const finalTimestamp = ISOTimestamp + Number(timezoneOffsetHour) * 60 * 60 * 1000 + Number(timezoneOffsetMinutes) * 60 * 1000
    // console.log('timezone offset', timezone, timezoneOffset, finalTimestamp)
    // console.log('reg', reg.exec(timezone), timezone)
    return finalTimestamp
  }
}
